export function setGformHoneypot() {
	if (!window.WPDATA.gforms_installed) {
		return;
	}

	if (typeof jQuery == 'undefined') {
		return;
	}

	jQuery(document).on('submit', 'form[data-formid]', function (evt) {
		const el = evt.target;
		if (!el.querySelector('[name="version_hash"]')) {
			const hiddenInput = `<input
				type="hidden"
				name="version_hash"
				value="${window.gform_theme_config?.common?.form?.honeypot?.version_hash}"
			/>`;
			el.insertAdjacentHTML('beforeend', hiddenInput);
		}
	});
}

export function evalScripts(next) {
	if (!window.WPDATA.gforms_installed) {
		return;
	}

	var parser = new DOMParser();
	var htmlDoc = parser.parseFromString(next.html, 'text/html');
	const scripts = htmlDoc.getElementsByTagName('script');

	function evalInWindow(src) {
		// GF's inline scripts bail out on `event && event.defaultPrevented`, which
		// would read whatever event happens to be in flight. Shadow it with an
		// undefined parameter instead of overwriting window.event: GF 3's submit
		// button calls window.event.preventDefault(), so a stale or dummy value
		// there makes the browser submit the form a second time.
		const func = function (event) {
			eval(src);
		};

		func.call(window);
	}

	[...scripts].forEach((script) => {
		if (script.hasAttribute('data-barba-include')) {
			let src = script.innerHTML;

			try {
				evalInWindow(src);
			} catch (e) {
				console.error(e);
			}
		}
	});
}
